import * as React from 'react';
export const docsendSvg = React.forwardRef(function docsendSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7F5F2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 5C9.444 5 5 8.883 5 16.07v1.473c0 7.455 4.114 10.892 10.978 10.892C22.578 28.435 27 24.93 27 17.52v-.804H16V5Z',
      fill: '#0061FE',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27 16.717V5H16l11 11.717Z',
      fill: '#1E1919',
    }),
  );
});
docsendSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var docsend = {
  category: 'brand',
  colorable: false,
  name: 'docsend',
  svg: docsendSvg,
};
